import React, { useEffect, useState } from 'react';
import { Trans } from "react-i18next";
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
export default function EstimationValidationSuccess() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        // Vérifier le paiement
        setTimeout(() => setLoading(false), 1500);
    }, [sessionId]);
    if (loading) {
        return (<div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-5xl mb-4">⏳</div>
          <p className="text-gray-600"><Trans i18nKey="estimationValidation.success.ui.verificationDuPaiement"/></p>
        </div>
      </div>);
    }
    return (<div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-lg shadow-lg p-12 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={48} className="text-green-600"/>
          </div>
          
          <h1 className="text-3xl font-light mb-4"><Trans i18nKey="estimationValidation.success.ui.paiementConfirme"/></h1>
          
          <p className="text-gray-700 mb-6 font-light leading-relaxed"><Trans i18nKey="estimationValidation.success.ui.votreDemandeDeValidationAEteTransmiseANotre"/> <strong><Trans i18nKey="estimationValidation.success.ui.4872hOuvres"/></strong>.
          </p>

          <div className="bg-blue-50 rounded-lg p-6 mb-8">
            <h3 className="font-semibold mb-3"><Trans i18nKey="estimationValidation.success.ui.prochainesEtapes"/></h3>
            <ol className="text-left text-sm space-y-2">
              <li className="flex items-start gap-2">
                <span className="font-bold">1.</span>
                <span><Trans i18nKey="estimationValidation.success.ui.vousRecevrezUnEmailDeConfirmationImmediatement"/></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold">2.</span>
                <span><Trans i18nKey="estimationValidation.success.ui.notreEquipeAnalyseraVotreEstimationDansLes4872h"/></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold">3.</span>
                <span><Trans i18nKey="estimationValidation.success.ui.vousRecevrezLeRapportDetailleParEmail"/></span>
              </li>
            </ol>
          </div>

          <div className="flex gap-4 justify-center">
            <Link to="/estimation" className="px-6 py-3 bg-black text-white rounded-sm hover:bg-gray-800 transition"><Trans i18nKey="estimationValidation.success.ui.retourAuxEstimations"/> </Link>
            <Link to="/mon-compte" className="px-6 py-3 border-2 border-gray-300 rounded-sm hover:border-black transition"><Trans i18nKey="estimationValidation.success.ui.monCompte"/> </Link>
          </div>
        </div>
      </div>
    </div>);
}
